export { default as findPeopleOperation } from 'owa-service/lib/operation/findPeopleOperation';
